import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SupportTicket } from "../../models/support.models";

@Component({
    selector: 'app-chat-support-tickets',
    templateUrl: './chat-support-tickets.component.html',
    styleUrls:['./chat-support-tickets.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ChatSupportTickets implements OnInit{
    @Input() supportTickets: SupportTicket[] = [];

    ngOnInit(): void {
       this.formatSupportTicketsForDisplay()
    } 

    //Returns the class name which for the status box
    getStatusClass(status: string): string {
        const normalizedStatus = (status).toLowerCase().trim();
        switch (normalizedStatus) {
            case 'open':
                return 'status-open';
            case 'new':
                return 'status-new';
            case 'closed':
                return 'status-closed';
            case 'hold':
                return 'status-hold';
            case 'pending':
                return 'status-pending';
            default:
                return 'status-open';
        }
    }

     //Transforms support ticket data by formatting the requestedOn and lastUpdated fields for UI display.
    formatSupportTicketsForDisplay() {
        this.supportTickets = this.supportTickets.map(ticket => ({
            ...ticket,
           requestedOn: this.formatTicketTimestamp(ticket.requestedOn),
           lastUpdated: this.formatTicketTimestamp(ticket.lastUpdated)
        }));
    }


    // Formats ticket timestamps based on recency
    // (e.g:- Just now, Today, 09:02AM, previousDay , 10:05AM, Feb 01 at 9:02AM, Feb 01, 2025 at 9:02AM).
    formatTicketTimestamp(value: string): string {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value || '-';
        }

        const now = new Date();
        const diffInSeconds = (now.getTime() - date.getTime()) / 1000;
        // Time is within the last 1 minute
        if (diffInSeconds < 60) {
            return 'Just now';
        }
        const isToday = date.toDateString() === now.toDateString();
        const previousDay = new Date(now);
        previousDay.setDate(now.getDate() - 1);
        const ispreviousDay = date.toDateString() === previousDay.toDateString();

        const time = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).format(date).replace(' ', '');

        if (isToday) { 
            return `Today, ${time}`; 
        }

        if (ispreviousDay) { 
            return `Yesterday , ${time}`; 
        }

        const isCurrentYear = date.getFullYear() === now.getFullYear();
        const monthDay = new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit' }).format(date);

        if (isCurrentYear) {
             return `${monthDay} at ${time}`; 
        }

        const monthDayYear = new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(date);
        return `${monthDayYear} at ${time}`;
    }
}
